module.exports = __webpack_public_path__ + "img/08.f0575798.png";